import React, { useEffect, useCallback, useState} from 'react';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import {getEffectsComponent} from 'components/effects/getEffectsComponent.js';
import {EFFECTS} from 'constants/arrangement-modes.js';
import {
    setArrangementBottomMode,
    setArrangementPatternSelected} from 'actions/index.js';
import AutomationToolbar from '../installation/AutomationToolbar.js';
import PianoRollComponent from 'components/pianoroll/PianoRollComponent.js';
import {connect} from 'react-redux';

const ArrangementBottom = ({
    setPatternSelected,
    patternSelected,
    sequencerEngine,
    bottomHeight,
    selectedEvents,
    selectedTrack,
    showTracks,
    bottomMode,
    currentSubSequence,
    setBottomMode
}) => { 
    let style = {
        height: bottomHeight
    };


    useEffect(() => {
        if (patternSelected && selectedTrack) {
            selectedTrack.updateSteps();
        }
    }, [patternSelected, selectedTrack]);

    useEffect(() => {
        return () => setPatternSelected(undefined);
    }, []);

    if ((!patternSelected && bottomMode !== EFFECTS) || !showTracks) {
        return [];
    }
    
    let toolbar = '';
    let content = '';
    let track = undefined;
    if (selectedTrack !== undefined) {
        track = selectedTrack;

        if (track) {
            toolbar = (
                <AutomationToolbar
                  hideAutomation={true}
                  hide={() => {
                      setPatternSelected(undefined);
                      setBottomMode(PIANO_ROLL);
                  }}
                  track={track} sequencerEngine={sequencerEngine}/>
            );
        }
        if (bottomMode === EFFECTS) {
            content = getEffectsComponent(track);
        } else if (bottomHeight > 25) {
            let pattern = track.patterns[patternSelected.patternNumber];
            content = (
                <PianoRollComponent
                  parentClassName="arrangement-bottom-container"
                  isLooping={false}
                  pattern={pattern}
                  scale={0.5}
                  installation={true}
                  sequencerEngine={sequencerEngine}
                  hideToolbar={true}
                  track={track}
                />);
        }
    } else {
        style.height = 0;
    }

    return (
        <div
          style={style}
          className="arrangement-bottom-container">
          {toolbar}
          {content}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let sub = props.sequencerEngine.currentSubSequence;
    return {
        selectedEvents: state.arrangement.selectedEvents,
        currentSubSequence: props.sequencerEngine.currentSubSequence,
        selectedTrack: props.sequencerEngine.tracks[state.mix.selectedTrack],
        bottomHeight:   state.arrangement.bottomHeight,
        patternSelected: state.arrangement.patternSelected,
        showTracks: state.arrangement.showTracks[sub.id],
        bottomMode: state.arrangement.bottomMode
        
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPatternSelected: (x) => dispatch(setArrangementPatternSelected(x)),
        setBottomMode: (x) => dispatch(setArrangementBottomMode(x))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArrangementBottom);
